import '../css/home.css';
import { useState, useRef, useEffect } from 'react';
import collage from '../assets/pics/collage.png'
import admiringCat from '../assets/pics/admiring_cat.png';
import catAndHer from '../assets/pics/cat_and_her.png';
import herPic2 from '../assets/pics/her2.png';
import voiceNote1 from '../assets/audio/laugh.mpeg';
import voiceNote2 from '../assets/audio/laugh2.mpeg';
import laughAnimation from '../assets/animations/laughing cat.json';
import { Player } from '@lottiefiles/react-lottie-player';
import explodingHeart from '../assets/animations/exploding heart.json';
import squeezyBunny from '../assets/animations/Squeeze bunny.json';
import catKiss from '../assets/animations/CAT KISS.json';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';
import downArrow from '../assets/animations/Down Arrow.json';

const cards = [
    {
        id: 0,
        title: "There's millions of reasons why I love you dummy...",
        caption: "but here are some of them I would like to talk about 💌",
        isIntro: true,
    },
    {
        id: 1,
        title: "You're the prettiest girl I've ever seen 🌸",
        caption: "You know I can't stop staring once I start looking at you.",
        hasCollage: true,
    },
    {
        id: 2,
        title: "You love cats so much, just like me 😼",
        caption: "Both of these cats look so adorableee.",
        hasCatPic: true,
    },
    {
        id: 3,
        title: "I love the way you sound, it's literally music to my ears 🎵🎶",
        caption: "Especially when you laugh hehehehe",
        hasVoiceNote: true,
    },
    {
        id: 4,
        title: "You always hear me out when I want to express myself...",
        caption: "Even when we fight, we never get disrespectful. That means sooo much to me.🥰🤍❤️",
        caption2: "I love you so much for that.",
        caption3: "And I always wanna keep you happy my love but fights are bound to happen so I am sure we will get through them...",
        caption4: "MWAH     MWAH      MWAH",
        caption5: "I JUST LOVE YOU SOOOO MUCH OMG!!"
    },
    {
        id: 5,
        title: "You're sooo pretty 😍",
        caption: "I can't stop saying it again and again and again...",
        hasPic2: true,
    },
    {
        id: 6,
        title: "💝 I love listening to you yap 💝",
        caption: "And I love when you listen to me yap about the things I like.",
        caption2: "We're so similar to each other and maybe that's why we can understand each other so well...",
        caption3: "I adore it so much when you tell me about your day. I cherish it so much that I wanna hear about every single day of your life from this point on.",
        caption4: "🧑🏻‍🤝‍👩🏻",
        hasLaughAnim: true,
    },
];

function Typewriter({ text }) {
    const [displayed, setDisplayed] = useState('');
    const [index, setIndex] = useState(0);

    useEffect(() => {
        if (index < text.length) {
            const timer = setTimeout(() => {
                setDisplayed(prev => prev + text[index]);
                setIndex(prev => prev + 1);
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [index, text]);

    return <h1 className="typewriter-heading">{displayed}<span className="cursor">|</span></h1>;
}

function CustomAudioPlayer({ src }) {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const [duration, setDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);

    const togglePlay = () => {
        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    const handleTimeUpdate = () => {
        const current = audioRef.current.currentTime;
        const dur = audioRef.current.duration;
        setCurrentTime(current);
        const p = (current / dur) * 100;
        setProgress(p);
        audioRef.current.parentElement.querySelector('.progress-bar').style.setProperty('--progress', `${p}%`);
    };

    const handleLoadedMetadata = () => {
        setDuration(audioRef.current.duration);
    };

    const handleSeek = (e) => {
        const newTime = (e.target.value / 100) * duration;
        audioRef.current.currentTime = newTime;
        setProgress(e.target.value);
    };

    const handleEnded = () => {
        setIsPlaying(false);
        setProgress(0);
    };

    const formatTime = (t) => {
        const m = Math.floor(t / 60);
        const s = Math.floor(t % 60).toString().padStart(2, '0');
        return `${m}:${s}`;
    };

    return (
        <div className="custom-player">
            <audio
                ref={audioRef}
                src={src}
                onTimeUpdate={handleTimeUpdate}
                onLoadedMetadata={handleLoadedMetadata}
                onEnded={handleEnded}
            />
            <button className="play-btn" onClick={togglePlay}>
                {isPlaying ? '⏸' : '▶'}
            </button>
            <div className="player-right">
                <input
                    type="range"
                    className="progress-bar"
                    value={progress}
                    onChange={handleSeek}
                    min="0"
                    max="100"
                />
                <div className="time-display">
                    <span>{formatTime(currentTime)}</span>
                    <span>{formatTime(duration)}</span>
                </div>
            </div>
        </div>
    );
}
export default function Home() {
    const [current, setCurrent] = useState(0);
    const [direction, setDirection] = useState('next');
    const [animating, setAnimating] = useState(false);
    const [showQuestion, setShowQuestion] = useState(false);
    const [showCelebration, setShowCelebration] = useState(false);
    const [noPos, setNoPos] = useState({ x: 0, y: 0 });
    const audioRef = useRef(null);
    const navigate = useNavigate();

    const goNext = () => {
        if (animating) return;
        if (current === cards.length - 1) {
            setShowQuestion(true);
            return;
        }
        setDirection('next');
        setAnimating(true);
        setTimeout(() => {
            setCurrent(prev => prev + 1);
            setAnimating(false);
        }, 400);
    };

    const goPrev = () => {
        if (animating || current === 0) return;
        setDirection('prev');
        setAnimating(true);
        setTimeout(() => {
            setCurrent(prev => prev - 1);
            setAnimating(false);
        }, 400);
    };

    const handleNoHover = () => {
        const x = (Math.random() - 0.5) * 400;
        const y = (Math.random() - 0.5) * 400;
        setNoPos({ x, y });
    };

    const card = cards[current];

    if (showCelebration) {
        return (
            <div className="celebration-page">
                <div className="floating-hearts-bg"></div>
                <div className="celebration-text">
                    <Player
                        autoplay
                        loop
                        src={catKiss}
                        style={{ height: '20rem', width: '20rem', marginTop: '-15rem', marginBottom: '-3rem' }}
                    />
                    <h1 className="celebration-title">I'm so happy that you're with me!!</h1>
                </div>
                <Player
                    autoplay
                    loop
                    src={downArrow}
                    style={{
                        height: '6rem',
                        width: '6rem',
                        position: 'fixed',
                        bottom: '4.5rem',
                        right: '3rem'
                    }}
                />
                <button className="logout-btn" onClick={async () => {
                    await supabase.auth.signOut();
                    navigate('/');
                }}>
                    Logout
                </button>
            </div>
        );
    }

    if (showQuestion) {
        return (
            <div className="question-page">
                <div className="floating-hearts-bg"></div>
                <div className="question-card">
                    <Player
                        autoplay
                        loop
                        src={squeezyBunny}
                        style={{ height: '20rem', width: '20rem', marginTop: '-20rem' }}
                    />
                    <h1 className="question-text">Would you like to be my girlfriend? 💍</h1>
                    <div className="question-buttons">
                        <button className="yes-btn" onClick={() => setShowCelebration(true)}>
                            Yes 💗
                        </button>
                        <button
                            className="no-btn"
                            style={{ transform: `translate(${noPos.x}px, ${noPos.y}px)` }}
                            onMouseEnter={handleNoHover}
                        >
                            No
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="home-page">
            <div className="floating-hearts-bg"></div>
            <Typewriter text="Reasons why I love you..." />
            <Player
                autoplay
                loop
                src={explodingHeart}
                style={{ height: '10rem', width: '10rem', marginLeft: '47.5rem', marginTop: '-10.5rem' }}
            />
            <div className={`flashcard ${animating ? (direction === 'next' ? 'slide-out-left' : 'slide-out-right') : 'slide-in'}`}>

                {card.isIntro && (
                    <div className="intro-card">
                        <h2 className="intro-title">{card.title}</h2>
                        <p className="intro-caption">{card.caption}</p>
                    </div>
                )}

                {/* Card 1 — collage + admiring cat */}
                {card.hasCollage && (
                    <div className="card-images-overlay">
                        <img src={collage} alt="her" className="collage-card-img" />
                        <img src={admiringCat} alt="cat" className="admiring-cat-img" />
                    </div>
                )}

                {/* Card 2 — her with cat */}
                {card.hasCatPic && (
                    <div className="card-single-img">
                        <img src={catAndHer} alt="her and cat" className="single-img" />
                    </div>
                )}

                {/* Card 3 — voice note */}
                {card.hasVoiceNote && (
                    <div className="voice-note-wrapper">
                        <CustomAudioPlayer src={voiceNote1} />
                        <CustomAudioPlayer src={voiceNote2} />
                    </div>
                )}

                {/* Card 5 — second pic of her */}
                {card.hasPic2 && (
                    <div className="card-single-img">
                        <img src={herPic2} alt="her" className="single-img" />
                    </div>
                )}

                {!card.isIntro && (
                    <div className="card-content">
                        <h2 className="card-title">
                            {card.title}
                            {card.hasLaughAnim && (
                                <Player
                                    autoplay
                                    loop
                                    src={laughAnimation}
                                    style={{ height: '7rem', width: '7rem', display: 'inline-block', verticalAlign: 'middle', marginLeft: '0.5rem' }}
                                />
                            )}
                        </h2>
                        <p className="card-caption">{card.caption}</p>
                        {card.caption2 && <p className="card-caption">{card.caption2}</p>}
                        {card.caption3 && <p className="card-caption">{card.caption3}</p>}
                        {card.caption4 && <p className="card-caption">{card.caption4}</p>}
                        {card.caption5 && <p className="card-caption">{card.caption5}</p>}
                    </div>
                )}
                <div className="card-nav">
                    <button className="nav-btn" onClick={goPrev} disabled={current === 0}>←</button>
                    <span className="card-counter">{current + 1} / {cards.length}</span>
                    <button className="nav-btn" onClick={goNext}>
                        {current === cards.length - 1 ? '💌' : '→'}
                    </button>
                </div>
            </div>
        </div>
    );
}